export enum PromoCreatorTypeEnum {
  SMO_MARKETING = "SMO_MARKETING",
  MALL_MARKETING = "MALL_MARKETING",
  APP_DEVELOPMENT = "APP_DEVELOPMENT"
}

export const PROMO_CREATOR_CHOICES = [
  {
    label: "SMO Marketing",
    value: PromoCreatorTypeEnum.SMO_MARKETING
  },
  {
    label: "Mall Marketing",
    value: PromoCreatorTypeEnum.MALL_MARKETING
  },
  {
    label: "App Development",
    value: PromoCreatorTypeEnum.APP_DEVELOPMENT
  }
];
